<app-settings-base
  title="{{'vatNumberVerificationSettings.title' | translate}}"
  description="{{'vatNumberVerificationSettings.text' | translate}}"
  details="{{'vatNumberVerificationSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/vatnumber-verification">
</app-settings-base>
